import React from "react";

const VerComentariosModal = ({ visible, onClose, data }) => {
    if (!visible) return null;

    return (
        <div
            style={{
                position: "fixed",
                inset: 0,
                background: "rgba(15,23,42,.45)",
                backdropFilter: "blur(3px)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 10000
            }}
        >
            <div
                style={{
                    width: "750px",
                    maxWidth: "95%",
                    maxHeight: "85vh",
                    background: "#fff",
                    borderRadius: "14px",
                    overflow: "hidden",
                    boxShadow: "0 18px 45px rgba(0,0,0,.18)"
                }}
            >
                {/* Encabezado */}
                <div
                    style={{
                        background: "#219ebc",
                        color: "#fff",
                        padding: "18px 24px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}
                >
                    <h3
                        style={{
                            margin: 0,
                            fontSize: "20px",
                            fontWeight: 600
                        }}
                    >
                        Comentarios del formulario
                    </h3>

                    <button
                        onClick={onClose}
                        style={{
                            border: "none",
                            background: "rgba(255,255,255,.15)",
                            color: "#fff",
                            width: "34px",
                            height: "34px",
                            borderRadius: "8px",
                            cursor: "pointer",
                            fontSize: "18px"
                        }}
                    >
                        ✕
                    </button>
                </div>

                {/* Contenido */}
                <div
                    style={{
                        padding: "25px",
                        maxHeight: "70vh",
                        overflowY: "auto",
                        background: "#f8fafc"
                    }}
                >
                    {data?.respuestas?.length === 0 && (
                        <div
                            style={{
                                textAlign: "center",
                                color: "#64748b"
                            }}
                        >
                            No existen respuestas.
                        </div>
                    )}

                    {data?.respuestas?.map((r, i) => (
                        <div
                            key={i}
                            style={{
                                background: "#fff",
                                borderRadius: "12px",
                                padding: "18px",
                                marginBottom: "18px",
                                border: "1px solid #e5e7eb",
                                boxShadow: "0 3px 10px rgba(0,0,0,.05)"
                            }}
                        >
                            {/* Pregunta */}
                            <div
                                style={{
                                    color: "#023047",
                                    fontWeight: 700,
                                    fontSize: "16px",
                                    marginBottom: "12px"
                                }}
                            >
                                {i + 1}. {r.pregunta}
                            </div>

                            {/* Respuesta */}
                            <div
                                style={{
                                    background: "#eef6fb",
                                    borderLeft: "5px solid #219ebc",
                                    padding: "12px",
                                    borderRadius: "8px",
                                    color: "#334155",
                                    marginBottom: "12px"
                                }}
                            >
                                <strong>Respuesta</strong>
                                <div style={{ marginTop: "6px" }}>
                                    {r.respuesta}
                                </div>
                            </div>

                            {/* Observación */}
                            {r.comentario ? (
                                <div
                                    style={{
                                        background: "#fff8e6",
                                        borderLeft: "5px solid #fb8500",
                                        padding: "12px",
                                        borderRadius: "8px"
                                    }}
                                >
                                    <strong style={{ color: "#fb8500" }}>
                                        Observación
                                    </strong>

                                    <div
                                        style={{
                                            marginTop: "6px",
                                            color: "#444"
                                        }}
                                    >
                                        {r.comentario}
                                    </div>
                                </div>
                            ) : (
                                <div
                                    style={{
                                        color: "#94a3b8",
                                        fontStyle: "italic"
                                    }}
                                >
                                    Sin observaciones.
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default VerComentariosModal;